import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import CorporateCustomerMenu from './corporateCustomerMenu';
import CorporateMenu from './corporateMenu';
import DataLoading from '../components/dataLoading';
import { useTheme } from '../hooks/useTheme';
import AccountMenu from './accountMenu';
import { getCall } from '../hooks/Network';
import AssociateBackOffice from './customers/associateBackOffice';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SearchAssociate from '../components/searchAssociate';
import { useDispatch } from 'react-redux';
import { setSubscriptionss } from '../slices/subscriptions';
import TawkToChat from '../features/widgets/components/Task';
import { useClientUser } from '../providers/client.provider';
import { useSelector } from 'react-redux';
import ThemeToggle from '../components/ThemeToggle';
import { Box, useTheme as muiThemer } from '@mui/material';
import SidebarToggle from '../components/SideBarToggle';
import { AllowByUserRole } from '../components/permission';

// Layout Component

const Layout = ({ customerId, pageId }) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const params = useParams();
  const { t } = useTranslation();
  const { theme, loading, error } = useTheme();
  const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
  const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID;
  const muiTheme = muiThemer();

  const dispatch = useDispatch();
  const { clientUser } = useClientUser();

  const apiToken = JSON.parse(localStorage.getItem('apiToken') || '{}');
  const bearerToken = apiToken?.jwtToken;
  const apiTokens = localStorage.getItem('apiToken');
  const clientUserRole = apiToken?.userRole || clientUser?.userRole;
  const user = JSON.parse(localStorage.getItem('token') || '{}');
  const associateId =
    apiToken.associateId === 0 ? params.customerId : apiToken?.associateId;
  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth < 992);

  // SLIDER HOVER EFFECT
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const sidebarExpanded = useSelector((state) => state.ui.sidebarExpanded);
  const mobileSearchOpen = useSelector((state) => state.ui.mobileSearchOpen);
  const isSidebarOpen = sidebarExpanded || isSidebarExpanded;
  useEffect(() => {
    document.body.classList.toggle('sidebar-expanded', sidebarExpanded);
  }, [sidebarExpanded]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.innerWidth < 992);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // useEffect(() => {
  //   if(clientUser == "ClientUser" && params.customerId != apiToken?.associateId){
  //     window.location.href = `/customers/${apiToken?.associateId}/dashboard`;
  //   }
  // },[params.customerId])

  useEffect(() => {
    const usedDeepLink = sessionStorage.getItem('usedDeepLink');

    if (
      !usedDeepLink && // ✅ Only redirect if no deep link was used
      clientUserRole === 'ClientUser' &&
      params?.customerId != apiToken?.associateId
    ) {
      window.location.href = `/customers/${apiToken?.associateId}/dashboard`;
    }

    // Clear the flag after mount to prevent blocking future intended redirects
    if (clientUserRole === 'ClientUser') {
      sessionStorage.removeItem('usedDeepLink'); // ✅ clean up
    }
  }, [params?.customerId]);

  const getAssociteSubscription = async () => {
    let sParams = {
      url: 'getAssociateSubscription',
      urlParams: { associateId: associateId },
      headers: { Authorization: 'Bearer ' + bearerToken },
    };
    try {
      if (params?.customerId) {
        const resp = await getCall(sParams);
        if (resp?.status === 200 && resp?.data) {
          setSubscriptions(resp.data || []);
          dispatch(setSubscriptionss(resp.data || []));
          // if (resp.data.some((subscription) => subscription.subscriptionId === 2)) {
          //   getSolexx()
          // }
        } else {
          console.error('Failed to fetch subscriptions:', resp);
        }
      }
    } catch (error) {
      console.error('Error in getAssociteSubscription:', error);
    }
  };
  useEffect(() => {
    getAssociteSubscription();
  }, [params?.customerId]);

  if (loading) return <DataLoading title={t('loadingTheme')} />;
  if (error) return `${t('errorC')} ${error}`;

  const inlineStyle = {
    '--tblr-navbar-bg': theme?.headerColor ?? '#1d273b',
    '--tblr-navbar-border-color': theme?.headerColor ?? '#243049',
    '--tblr-icon-color': theme?.headerTextColor ?? 'rgba(255,255,255,.7)',
    '--tblr-nav-link-font-size': '1rem',
    '--tblr-nav-link-font-weight': '400',
    '--tblr-body-color': theme?.headerTextColor ?? 'rgba(255, 255, 255, 0.8)',
  };

  if (theme?.favicon?.url) {
    const favicon = document.querySelector('link[rel="icon"]');

    if (favicon) {
      favicon.href = theme?.favicon?.url;
    } else {
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      newFavicon.href = theme?.favicon?.url;
      document.head.appendChild(newFavicon);
    }
  }

  document.title = theme?.title ? `${theme.title} ` : 'NOA';

  return (
    <>
      <aside
        className={`navbar navbar-sticky navbar-vertical navbar-expand-lg relative ${isSidebarExpanded || sidebarExpanded ? 'expanded ' : ''} ${mobileSearchOpen ? 'mb-search-open' : ''}`}
        style={inlineStyle}
        // onMouseEnter={() => !sidebarExpanded && setIsSidebarExpanded(true)}
        // onMouseLeave={() => !sidebarExpanded && setIsSidebarExpanded(false)}
        onMouseEnter={() => {
          if (!sidebarExpanded) {
            // dispatch(toggleSidebar()); // 🔥 expand
            setIsSidebarExpanded(true);
          }
        }}
        onMouseLeave={() => {
          if (!sidebarExpanded) {
            setIsSidebarExpanded(false);
            // dispatch(toggleSidebar()); // 🔥 collapse back
          }
        }}
      >
        <div className='container-fluid mobile-header'>
          <button
            className='navbar-toggler me-2'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#sidebar-menu'
            aria-controls='sidebar-menu'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <h1 className='navbar-brand navbar-brand-autodark mb-logo ms-0 sidebar-brand'>
            <a
              href='/'
              className={`d-flex ${isSidebarExpanded ? 'flex-row gap-3' : 'flex-column gap-2'} logo-wrapper `}
            >
              <img
                src={theme?.logo?.url ?? '/images/logo.png'}
                alt='Pillars'
                className='navbar-brand-image'
                style={{ width: isMobileDevice && '97px' }}
              />
              {!isMobileDevice && (
                <div
                  className={`${isSidebarExpanded ? 'd-flex position-absolute gap-2 mb-2 top-0 end-0' : 'd-none'} `}
                >
                  <SidebarToggle
                    isSidebarHovered={isSidebarExpanded}
                    setIsSidebarHovered={setIsSidebarExpanded}
                  />
                </div>
              )}
            </a>

            {/* {!isMobileDevice && (
              <div className='sidebar-toggle-control mx-2'>
                <label className='circle-checkbox'>
                  <input
                    type='checkbox'
                    checked={sidebarExpanded}
                    onChange={() => dispatch(toggleSidebar())}
                  />
                  <span className='circle-ui' />
                </label>
              </div>
            )} */}
          </h1>

          {clientUserRole != 'ClientUser' && <SearchAssociate />}

          {isMobileDevice ? (
            <div className='navbar-nav flex-row'>
              <ThemeToggle useLabel={false} iconColor='#ccc' />

              <div
                className='nav-item dropdown  mb-account-menu'
                style={{
                  flexDirection: isMobileDevice ? 'row' : 'column',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                <AccountMenu />
              </div>
            </div>
          ) : null}
          <Box className='collapse navbar-collapse' id='sidebar-menu'>
            <AllowByUserRole
              allowedRoles={['Admin', 'ClientAdmin', 'CustomerService', 'Compliance']}
            >
              {params?.customerId ? (
                <CorporateCustomerMenu subscriptions={subscriptions} />
              ) : (
                <CorporateMenu />
              )}
            </AllowByUserRole>
            <AllowByUserRole allowedRoles={['ClientUser']}>
              <ul
                className={`admin-navbar-nav navbar-nav mui-mode-${muiTheme.palette.mode}`}
              >
                <AssociateBackOffice
                  customerId={customerId}
                  subscriptions={subscriptions}
                  pageId={pageId}
                />
              </ul>
            </AllowByUserRole>
          </Box>
        </div>
      </aside>

      <Outlet />

      <div id='success-alert' className='pop-up' style={{ display: 'none' }}>
        <div className='popup-inp-div'>
          <button
            className='bn-close'
            onClick={() => {
              document.getElementById('success-alert').style.display = 'none';
            }}
          >
            X
          </button>

          <div id='success-mesg-elm'> </div>
        </div>
      </div>

      <div id='warning-alert' className='pop-up' style={{ display: 'none' }}>
        <div className='popup-inp-div'>
          <button
            className='bn-close'
            onClick={() => {
              document.getElementById('warning-alert').style.display = 'none';
            }}
          >
            X
          </button>

          <div id='warning-mesg-elm'> </div>
        </div>
      </div>

      {/* Only Client User */}

      {clientUserRole === 'ClientUser' && user && propertyId && widgetId && (
        <TawkToChat
          userId={user?.userId}
          name={`${user?.firstName} ${user?.lastName}`}
          email={user?.username}
        />
      )}

      {/* all users */}

      {/* <TawkToChat
        userId={user?.userId}
        name={`${user?.firstName} ${user?.lastName}`}
        email={user?.username}
      /> */}
    </>
  );
};

Layout.propTypes = {
  customerId: PropTypes.string,
  pageId: PropTypes.string,
};

export default Layout;
